/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { useThemeMode } from '_metronic/partials'
import moment from 'moment'
import 'moment-timezone'

interface Props {
  data: any
}

const StakingWeekChart: React.FC<Props> = ({ data }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const refreshChart = (weeklyReport: any[]) => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(chartRef.current, getChartOptions(weeklyReport))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart(data ?? [])

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode, data])

  return (
    <>
      {/* begin::Chart */}
      <div
        ref={chartRef}
        id='kt_charts_staking_week_chart'
        style={{ height: '300px' }}
        className='card-rounded-bottom'></div>
      {/* end::Chart */}
    </>
  )
}

function getChartOptions (weeklyReport: any[]): ApexOptions {
  return {
    grid: {
      padding: {
        top: 60,
      },
    },
    series: [
      {
        name: 'ตอกสำเร็จ',
        data: weeklyReport.map(report => report.totalCompleted),
      },
      {
        name: 'ตอกเสีย',
        data: weeklyReport.map(report => report.totalWasted),
      },
    ],
    colors: ['#1BC5BD', '#F64E60'],
    chart: {
      type: 'bar',
      height: 300,
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        distributed: false,
        borderRadius: 8,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      type: 'category',
      // title: {
      //   text: 'วันที่',
      // },
      categories: weeklyReport.map(report => moment(report.date).format('DD MMM')),
    },
    fill: {
      opacity: 1,
    },
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      markers: {
        width: 12,
        height: 12,
        radius: 6,
      },
      formatter: function (seriesName) {
        return seriesName + '\n'
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
  }
}

export default StakingWeekChart
